import { NgModule } from '@angular/core';
import { ClientManagementComponent } from './client-management.component';
import { TnxSharedModule } from 'tnx-shared';
import { ClientManagementFormComponent } from './client-form/client-management-form.component';
import { ClientManagementRoutes } from './client-management.routing';

export function declaration() {
    return [
        ClientManagementFormComponent,
        ClientManagementComponent,
    ];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class ClientManagementModule {
}

@NgModule({
    imports: [ClientManagementModule, ClientManagementRoutes],
    exports: [ClientManagementModule]
})
export class ClientManagementWithRouteModule {
}
